export default {
  // Hero Section
  'hero.badge': 'Fan Engagement Ökosystem',
  'hero.subtitle': 'Das transparente Fan Engagement Ökosystem',
  'hero.description': 'Eine globale Mobile-Gaming-Plattform, die Free-to-Play Gameplay, GamePass-Umsätze und eine NFT-basierte Asset-Ökonomie in einem klar strukturierten Ökosystem verbindet.',
  'hero.btnModel': 'Modell verstehen',
  'hero.btnFlow': 'Wertfluss ansehen',
  
  // Video Section
  'video.title': 'Die Vision von SuperOne vom CEO',
  'video.ceo': 'Andreas Christensen',
  'video.subtitle': 'vorgestellt',
  'video.soundNote': 'Klicken Sie auf das Video, um den Ton zu aktivieren',
  
  // What is SuperOne
  'what.title': 'Was ist',
  'what.description': 'Ein schnelles, kompetitives Quiz-Game rund um Sport, Kultur und Entertainment – basierend auf realen digitalen Umsätzen, nicht auf Einzahlungen ohne Gegenwert.',
  'what.feature1.title': 'Free-to-Play + GamePass',
  'what.feature1.desc': 'Kostenloser Einstieg mit Premium-Optionen für mehr Spielzeit',
  'what.feature2.title': 'NFT-Mietmodelle',
  'what.feature2.desc': 'Digitale Assets zur Vermietung an aktive Spieler',
  'what.feature3.title': 'Lootboxen als Assets',
  'what.feature3.desc': 'Digitale Besitztümer mit echtem Nutzwert',
  'what.feature4.title': 'Token Rewards',
  'what.feature4.desc': 'Belohnungen basierend auf Spielaktivität',
  'what.feature5.title': 'Umsatzbasiertes Affiliate',
  'what.feature5.desc': 'Provisionen aus realen Käufen, nicht aus Teilnahmegebühren',
  'what.feature6.title': 'Kompetitives Gaming',
  'what.feature6.desc': 'Schnelle Quiz-Battles mit echten Preisen',
  
  // App Section
  'app.badge': 'Jetzt verfügbar',
  'app.title': 'SuperOne ist',
  'app.titleHighlight': 'live',
  'app.subtitle': 'Lade die App jetzt herunter und erlebe das Battle Royale Quiz-Game',
  'app.downloadTitle': 'Jetzt herunterladen',
  'app.gamePrinciple': 'Das Spielprinzip',
  'app.gamePrincipleDesc': 'Ein schnelles, kompetitives Fußball-Quiz im Battle Royale Format',
  'app.prizePool': 'Preispool',
  'app.prizePoolDesc': 'Gewinne echte Geldpreise',
  'app.weekly': 'Wöchentlich',
  'app.daily': 'Täglich',
  'app.winners': 'Gewinner',
  'app.howItWorks': 'So funktioniert\'s',
  'app.step1.title': 'Free-to-Play',
  'app.step1.desc': '10 kostenlose Spiele täglich für jeden Spieler – kein Risiko, sofort loslegen',
  'app.step2.title': 'GamePass',
  'app.step2.desc': 'Mehr spielen? Kaufe einen GamePass für nur $1 und spiele unbegrenzt weiter',
  'app.step3.title': 'Gewinnen',
  'app.step3.desc': 'Tritt im Battle Royale an und gewinne echte Geldpreise – täglich und wöchentlich',
  'app.valueCreation': 'Klare Wertschöpfung',
  'app.valueCreationDesc': 'Die Wertschöpfung von SuperOne basiert auf realen GamePass-Käufen – nicht auf Einzahlungen oder Teilnahmegebühren',
  'app.freeGames': 'Free Games',
  'app.freeGamesDesc': 'Täglich kostenlos',
  'app.gamePassPrice': 'GamePass $1',
  'app.gamePassDesc': 'Unbegrenzt weiterspielen',
  'app.realRevenue': 'Echte Umsätze',
  'app.realRevenueDesc': 'Nachhaltiges Modell',
  
  // Traction Section
  'traction.badge': '7+ Monate Live-Pilot',
  'traction.title': 'Validierte',
  'traction.titleHighlight': 'Traction',
  'traction.description': 'Erfolgreicher Pilot über 7+ Monate mit 32 (50) Clubs und 22 Sprachen. Stickiness validiert über Engagement, Retention und Virality',
  'traction.source': 'Quelle: Verifizierte Daten von SuperOne',
  'traction.cashPrizes': 'Cash prizes',
  'traction.gamesPlayed': 'Games played',
  'traction.hoursPlayed': 'Hours played',
  'traction.uniquePlayers': 'Unique players',
  'traction.clubs': 'Clubs',
  'traction.languages': 'Sprachen',
  'traction.months': 'Monate',
  'traction.referrals': 'Referrals',
  'traction.stickinessTitle': 'Stickiness validiert',
  'traction.stickinessDesc': 'Die Pilot-Phase hat die drei entscheidenden Erfolgsfaktoren bestätigt',
  'traction.engagement': 'Engagement',
  'traction.engagementDesc': '35 Spiele täglich zeigen hohe Nutzeraktivität und Spielspaß',
  'traction.retention': 'Retention',
  'traction.retentionDesc': '3 Stunden täglich belegen starke Nutzerbindung über Monate',
  'traction.virality': 'Virality',
  'traction.viralityDesc': '27 monatliche Referrals demonstrieren organisches Wachstum',
  'traction.conclusion': 'Diese Kennzahlen bilden die Grundlage für die globale Skalierung von SuperOne',
  
  // Market Opportunity
  'market.badge': 'Globaler Wachstumsmarkt',
  'market.title': 'Markt',
  'market.titleHighlight': 'Opportunity',
  'market.description': 'Der Mobile Gaming Markt wächst exponentiell – SuperOne positioniert sich in einem Milliardenmarkt',
  'market.growth': 'Wachstum in 5 Jahren',
  'market.userGrowth': 'Nutzerwachstum weltweit',
  'market.mobileGamers': 'Mobile Gamer',
  'market.marketShare': 'Marktanteil',
  'market.marketShareDesc': 'Mobile Gaming ist das größte Segment der Gaming-Industrie',
  'market.quizTrivia': 'Quiz & Trivia',
  'market.quizTriviaDesc': 'Schnell wachsendes Segment mit hohem Engagement',
  'market.dailyTime': 'Täglich',
  'market.dailyTimeDesc': 'Durchschnittliche Spielzeit pro Mobile Gamer',
  'market.avgArpu': 'Avg. ARPU',
  'market.avgArpuDesc': 'Durchschnittlicher Umsatz pro Mobile Gaming User',
  'market.positioning': 'SuperOne Positionierung',
  'market.positioningDesc': 'SuperOne kombiniert die Stärken des Quiz & Trivia Segments mit innovativen Web3-Elementen und positioniert sich in einem $148.6B Markt bis 2029',
  
  // Monetization
  'monetization.badge': 'Monetarisierung validiert',
  'monetization.title': 'Bewährte',
  'monetization.titleHighlight': 'Monetarisierung',
  'monetization.description': 'SuperOne basiert auf erprobten Monetarisierungsmodellen der erfolgreichsten Mobile Games weltweit',
  'monetization.validated': 'Monetarisierung validiert im Pilot Game',
  'monetization.baseArpu': 'Base ARPU Game only',
  'monetization.fullArpu': 'Full ARPU Ads + data',
  'monetization.conversion': 'Conversion to paid',
  'monetization.annualArpu': 'Annual ARPU',
  'monetization.adViews': 'Annual ad views',
  'monetization.adRevenue': 'Annual ad revenue',
  'monetization.benchmark': 'SuperOne Benchmark',
  'monetization.benchmarkDesc': 'Mit $100-200 Annual ARPU positioniert sich SuperOne im mittleren Bereich erfolgreicher Mobile Games und nutzt bewährte Monetarisierungsstrategien der Gaming-Industrie.',
  
  // Roadmap
  'roadmap.badge': 'Wachstumsstrategie',
  'roadmap.title': 'Die Roadmap zu einem möglichen Tokenpreis von',
  'roadmap.subtitle': 'Fan Growth + Token Value – Wachstum zu 10M in 6 Monaten, 100M bis 2026 und 1B bis 2030',
  'roadmap.disclaimer': '(ohne Garantie)',
  'roadmap.activeFans': 'Active Fans',
  'roadmap.monetizedFans': 'Monetized Fans',
  'roadmap.grossRevenue': 'Gross Revenue',
  'roadmap.inStaking': 'In Staking',
  'roadmap.marketCap': 'Market Cap',
  'roadmap.virality': 'Virality of 2 - Probability 50%',
  'roadmap.arpuGrowth': 'ARPU Growth Path',
  'roadmap.cryptoMarket': 'The crypto market is estimated to grow 200% to beyond $10T by 2030',
  
  // Technology
  'tech.badge': 'Enterprise-Grade Stack',
  'tech.title': 'Bewährte',
  'tech.titleHighlight': 'Technologie',
  'tech.description': 'SuperOne basiert auf modernsten, skalierbaren Technologien – bewährt von führenden Tech-Unternehmen',
  'tech.trust': 'Vertrauen durch bewährte Technologie',
  'tech.performance': 'Hochperformant',
  'tech.performanceDesc': 'Schnell & flüssig',
  'tech.scalable': 'Skalierbar',
  'tech.scalableDesc': 'Millionen von Nutzern',
  'tech.secure': 'Sicher',
  'tech.secureDesc': 'Enterprise-Grade',
  
  // Two Perspectives
  'perspectives.title': 'Zwei Perspektiven,',
  'perspectives.titleHighlight': 'ein Ökosystem',
  'perspectives.forPlayers': 'Für Spieler',
  'perspectives.forOwners': 'Für Lootbox-Besitzer',
  'perspectives.gamepass.title': 'GamePass (Hauptumsatz)',
  'perspectives.gamepass.point1': '10 kostenlose Spiele täglich für jeden Nutzer',
  'perspectives.gamepass.point2': 'Mehr spielen? Kaufe einen Daily, Weekly oder Monthly GamePass',
  'perspectives.gamepass.point3': 'Primäre Monetarisierung – vollständig App-Store konform',
  'perspectives.nftRent.title': 'NFT-Miete',
  'perspectives.nftRent.point1': 'Spieler kaufen keine Lootboxen',
  'perspectives.nftRent.point2': 'Stattdessen mieten sie NFT-Items von Lootbox-Besitzern',
  'perspectives.nftRent.point3': 'In-App-Gebühren erzeugen echte Umsätze',
  'perspectives.tokenRewards.title': 'Token Rewards',
  'perspectives.tokenRewards.desc': 'Regelmäßige Token-Ausschüttungen basierend auf Spielaktivität und Lootbox-Kategorie',
  'perspectives.nftIncome.title': 'NFT-Mieteinnahmen',
  'perspectives.nftIncome.desc': 'Anteil der Mieteinnahmen bei jeder NFT-Vermietung – ein reiner Nutzungs-Revenue-Share',
  'perspectives.affiliate.title': 'Affiliate-Provisionen',
  'perspectives.affiliate.desc': 'Provisionen aus realen Umsätzen wie GamePass-Käufen – keine Teilnahmegebühren',
  
  // Value Flow
  'flow.title': 'Der',
  'flow.titleHighlight': 'Wertfluss',
  'flow.description': 'Kurz & transparent – so fließt der Wert im SuperOne-Ökosystem',
  'flow.step1.title': 'Umsatz entsteht',
  'flow.step1.desc': 'Spieler kaufen GamePass oder mieten NFT-Items → Realer In-App-Umsatz wird generiert',
  'flow.step2.title': 'Umsatzverteilung',
  'flow.step2.desc': 'Der generierte Umsatz wird transparent aufgeteilt:',
  'flow.step2.note': 'Alles basiert auf digitalem Konsum – nicht auf finanzieller Einbringung von Nutzern',
  
  // Why Sustainable
  'sustainable.title': 'Warum dieses Modell',
  'sustainable.titleHighlight': 'nachhaltig',
  'sustainable.subtitle': 'ist',
  'sustainable.reason1.title': 'Free-to-Play Einstieg',
  'sustainable.reason1.desc': 'Keine Barrieren – jeder kann kostenlos starten',
  'sustainable.reason2.title': 'GamePass Monetarisierung',
  'sustainable.reason2.desc': 'Bewährtes Modell aus der Gaming-Industrie',
  'sustainable.reason3.title': 'NFT-Assets zur Vermietung',
  'sustainable.reason3.desc': 'Digitale Besitztümer mit echtem Nutzwert',
  'sustainable.reason4.title': 'Aktivitätsbasierte Rewards',
  'sustainable.reason4.desc': 'Token-Belohnungen durch echte Spielaktivität',
  'sustainable.reason5.title': 'Umsatzbasiertes Affiliate',
  'sustainable.reason5.desc': 'Provisionen nur aus realen Käufen',
  'sustainable.reason6.title': 'Kein Finanzmodell',
  'sustainable.reason6.desc': 'Entertainment-Ökosystem mit Produktwert',
  'sustainable.conclusion': 'SuperOne ist kein Finanz- oder Investmentmodell, sondern ein Entertainment-Ökosystem mit realem Produktwert und realen Umsätzen.',
  
  // Telegram CTA
  'telegram.title': 'Noch Fragen zu SuperOne?',
  'telegram.description': 'Unser Telegram-Bot beantwortet alle deine Fragen und hilft dir, SuperOne noch besser zu verstehen!',
  'telegram.button': 'Zum Telegram-Bot',
  
  // Conclusion
  'conclusion.title': 'Fazit',
  'conclusion.description': 'SuperOne verbindet Gaming, digitale Assets und Belohnungsmechaniken in einem klaren, transparenten und nachhaltigen Modell.',
  'conclusion.value': 'Der gesamte wirtschaftliche Wert entsteht durch Nutzung, Spielaktivität und digitale Käufe – nicht durch neue Teilnehmer.',
  'conclusion.button': 'Jetzt mehr erfahren',
  
  // Disclaimer
  'disclaimer': 'Hinweis: DigitalSports ist unabhängiger Affiliate-Partner von SuperOne. Dies ist nicht die offizielle Unternehmenswebseite. Alle Daten und Fakten sind verifiziert und stammen vom Unternehmen SuperOne.',
};